module.exports = __webpack_public_path__ + "d308073b/img/verified-icon.f93bbc14.svg";